import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import Block from "./Block";
export default class ContentPlaceholderBlock extends Block {}
_defineProperty(ContentPlaceholderBlock, "NAME", 'content_placeholder_block');